import React from "react";
import { MdRestaurant } from "react-icons/md";

import styles from "./CutlerySelector.module.scss";

interface Props {
  value: number;
  onIncrement: () => void;
  onDecrement: () => void;
  min?: number;
  max?: number;
}

export const CutlerySelector: React.FC<Props> = ({
  value,
  onIncrement,
  onDecrement,
  min = 0,
  max = 10,
}) => {
  return (
    <div className={styles.Container}>
      <div className={styles.Icon}>
        <MdRestaurant size={20} />
      </div>

      <div className={styles.Info}>
        <span className={styles.Name}>Приборы</span>
        <span className={styles.Hint}>
          {value === 0 ? "Без приборов" : `${value} шт`}
        </span>
      </div>

      <div className={styles.Controls}>
        <button
          type="button"
          className={styles.Button}
          onClick={onDecrement}
          disabled={value <= min}
          aria-label="Меньше приборов"
        >
          −
        </button>

        <span className={styles.Value}>{value}</span>

        <button
          type="button"
          className={styles.Button}
          onClick={onIncrement}
          disabled={value >= max}
          aria-label="Больше приборов"
        >
          +
        </button>
      </div>
    </div>
  );
};